import React from 'react';
import Header from '../components/Header';

import './BlogLayout.css'; // Add CSS file

const BlogLayout = ({ children, user, isAuthenticated, handleLogout }) => {
  return (
    <div className="blog-layout">
      <Header 
        isAuthenticated={isAuthenticated} 
        user={user} 
        handleLogout={handleLogout} 
      />
      <main>{children}</main>
    </div>
  );
};

export default BlogLayout;
